<template>
  <transition name="slide-up">
    <div class="alert-mask" @click="closeAlert" v-show="isActive">
      <div class="alert-container">
        <span class="close">X</span>
        <div class="alert-clip">
          <img src="@/assets/img/alert.png" v-show="content.hasError" />
          <img src="@/assets/img/success.png" v-show="!content.hasError" />
        </div>
        <div class="alert-title">{{ content.title }}</div>
        <div class="alert-message">{{ content.message }}</div>
        <div class="alert-button">
          <button
            autofocus
            id="btn-close-alert"
            @click="closeAlert"
            :class="{ error: content.hasError }"
          >
            {{ content.button }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      isActive: "alert/getIsActive",
      content: "alert/getContent"
    })
  },

  updated() {
    document.getElementById("btn-close-alert").focus();
  },

  methods: {
    closeAlert() {
      this.$store.dispatch("alert/toggleAlert", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.alert-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: #00000040;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: $zIndex + 9999;

  .alert-container {
    width: 375px;
    padding: 20px;
    border-radius: 3px;
    background-color: #ffffff;
    text-align: center;
    padding: 25px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    @include mobile {
      width: 280px;
    }
  }

  .alert-clip {
    width: 200px;
    margin-bottom: 10px;

    @include mobile {
      width: 100px;
    }

    img {
      width: 100%;
    }
  }

  .alert-title {
    color: #aaa;
    margin: 10px;
    font-weight: bold;
  }

  .alert-message {
    color: #aaa;
    margin: 10px;
  }

  .alert-button {
    margin-top: 10px;

    button {
      background-color: #4fceb4;
      border: none;
      font-size: 18px;
      color: #fff;
      border-radius: 20px;
      padding: 10px 20px;
      cursor: pointer;

      &.error {
        background-color: #f89595;
      }

      &:hover {
        box-shadow: 0 0 5px 0 #aaa;
      }

      &:focus {
        outline: none;
      }
    }
  }

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    color: #666;
    cursor: pointer;
  }
}
</style>
